import { MiniGamesLobbyScreen } from '@/screens/index'

export default function () {
  return <MiniGamesLobbyScreen />
}
